var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"centerx"},_vm._l((_vm.mailContent.filter),function(item,index){return _c('li',{key:index},[_c('vs-checkbox',{attrs:{"vs-value":item},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}},[_vm._v(_vm._s(item.title))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }